import { Pipe, PipeTransform } from '@angular/core';

interface SalesOrderFilterItem {
  Material: string;
  Description: string;
}

@Pipe({
  name: 'salesOrderFilter',
  standalone: false,
})
export class SalesOrderFilterPipe implements PipeTransform {
  transform(
    value: SalesOrderFilterItem[] | undefined,
    args: string
  ): SalesOrderFilterItem[] | undefined {
    if (!args) return value;
    const filter = args.toLocaleLowerCase();
    return filter
      ? value.filter(
          (inventory) =>
            inventory.Material.toLocaleLowerCase().indexOf(filter) !== -1 ||
            inventory.Description.toLocaleLowerCase().indexOf(filter) !== -1
        )
      : value;
  }
}
